import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { KsefApiService } from '../../services/ksef-api.service';
import { KsefInvoice } from '../../models/ksef-invoice.model';
import { Roles } from 'src/app/shared/models/auth/role.model';
import { UserService } from 'src/app/shared/services/user.service';

export type KsefGeneralFilter = 'pending' | 'assigned';

@Component({
  selector: 'app-ksef-general-list',
  templateUrl: './ksef-general-list.component.html',
})
export class KsefGeneralListComponent implements OnInit {
  invoices$!: Observable<KsefInvoice[]>;
  currentFilter$!: Observable<KsefGeneralFilter>;
  Roles = Roles;
  isPrivilegedForAssignedTab = false;

  constructor(
    private ksefApi: KsefApiService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    const currentUser = this.userService.getCurrentUser();
    const roles = (currentUser && currentUser.user && currentUser.user.roles) || [];
    const privilegedRoles = [Roles.Staff, Roles.Manager, Roles.Admin];
    this.isPrivilegedForAssignedTab = roles.some((role) => privilegedRoles.includes(role));

    this.currentFilter$ = this.route.queryParams.pipe(
      map((params) => {
        const f = params['filter'];
        return f === 'assigned' ? 'assigned' : 'pending';
      }),
    );

    const allInvoices$ = this.ksefApi.getGeneralInvoices().pipe(shareReplay(1));
    this.invoices$ = this.currentFilter$.pipe(
      switchMap((filter) =>
        allInvoices$.pipe(
          map((list) => {
            if (!this.isPrivilegedForAssignedTab) {
              return list.filter((inv) => inv.employeeIdentifier == null);
            }
            return filter === 'assigned'
              ? list.filter((inv) => inv.employeeIdentifier != null)
              : list.filter((inv) => inv.employeeIdentifier == null);
          }),
        ),
      ),
    );
  }

  setFilter(filter: KsefGeneralFilter): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: filter === 'assigned' ? { filter: 'assigned' } : {},
      queryParamsHandling: '',
    });
  }

  statusClass(status: string): string {
    return (status || '').toLowerCase();
  }
}

